module.exports = "<div class=\"container\">\n\n\t<mo-header title=\"concept\"></mo-header>\n\n\t<main class=\"content wrapper\">\n\n\t\t<mo-nav sticky=\"true\"></mo-nav>\n\n\t\t<section class=\"content-box\" ng-bind-html=\"'concept.text' | translate\"></section>\n\n\t</main>\n\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/modules/site/concept/concept.html
// module id = 520
// module chunks = 0